import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CurrencyProvider } from "./context/CurrencyContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ChartProvider } from "./context/ChartContext";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <CurrencyProvider>
          <ChartProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<HomePage />} />
              </Routes>
            </BrowserRouter>
          </ChartProvider>
        </CurrencyProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
